module.exports = __webpack_public_path__ + "prod/1.42.2/img/fengtu-icon.01e64549.png";